/**
 * Tâche 1156 (Eric 2026-06-17) — « M'envoyer un courriel test ».
 *
 * Le guide du domaine (1151) disparaît dès que tout est vert : il manquait le
 * dernier maillon, vérifier qu'un courriel part VRAIMENT. Un clic, aucune
 * adresse à taper (c'est celle du compte connecté), et le résultat est dit
 * franchement — parti, ou refusé avec le motif exact de Resend.
 */
import { useState } from "react";
import { useLang } from "../../contexts/LanguageContext";
import axios from "axios";
import { toast } from "sonner";
import { PaperPlaneTilt } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

export const SelfTestEmailButton = ({ className = "" }) => {
  const { tr } = useLang();
  const [sending, setSending] = useState(false);
  const [last, setLast] = useState(null);

  const send = async () => {
    setSending(true);
    try {
      const res = await axios.post(
        `${API}/api/system-notifications/email-test-self`,
        {},
        { withCredentials: true }
      );
      setLast(res.data);
      if (res.data?.sent) {
        toast.success(`Courriel test envoyé à ${res.data.to}`);
      } else {
        toast.error(
          res.data?.reason
            ? `Refusé : ${res.data.reason}`
            : tr("Le courriel test n'est pas parti", "The test email did not go out")
        );
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Envoi test impossible");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className={`inline-flex flex-col gap-1 ${className}`}>
      <button
        type="button"
        onClick={send}
        disabled={sending}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-emerald-300 bg-white text-sm text-emerald-800 hover:bg-emerald-50 disabled:opacity-50"
        data-testid="self-test-email-button"
      >
        <PaperPlaneTilt size={16} />
        {sending ? tr("Envoi…", "Sending…") : tr("M'envoyer un courriel test", "Send me a test email")}
      </button>
      {last && (
        <span
          className={`text-xs ${last.sent ? "text-emerald-700" : "text-red-700"}`}
          data-testid="self-test-email-result"
        >
          {last.sent
            ? `Parti vers ${last.to} — vérifiez votre boîte (et les indésirables)`
            : `Refusé : ${last.reason || "motif inconnu"}`}
        </span>
      )}
    </div>
  );
};

export default SelfTestEmailButton;
